import React from 'react'
import GitHubCalendar from 'react-github-calendar';

function About() {
  return (
    <>
      <div className="bg-neutral-100 px-4 py-5 lg:pr-48">
        <div className="bg-white border border-neutral-300 max-w-screen-md px-4 py-8 mx-auto mt-20">
            {/* <!-- detailed info --> */}
            <main className="flex gap-x-10 mt-2 md:mt-5 lg:10">
                <div className="">
                    <section className="mb-8">
                        {/* <!-- about me --> */}
                        <h2 className="text-xl pb-1 border-b font-semibold">About me</h2>
                        <p className="mt-4 text-base leading-6">Meet Baraka Danny, aka Dan. I'm a Full-Stack Software Developer with a 
                        focus on Front-End Development and a passion for all things technology - 
                        from software development to visual design and information security. Join me on this 
                        journey of discovery and let's create something amazing together!.</p>

                    </section>

                    <section>
                        {/* <!-- Work--> */}
                        <h2 className="text-xl pb-1 border-b font-semibold">Work (Current Occupation)</h2>
                        <ul className='list-disc mt-4 pl-5'>
                            <li className="text-base leading-6">
                                I hold different roles in the software development industry. 
                                At Termas Designs in Toronto, Canada, I contribute as a full-stack 
                                software developer, creating innovative solutions for exceptional user experiences. 
                                Additionally, as a software engineer mentor at Springboard in California, 
                                I guide aspiring professionals in developing their skills for real-world projects.
                            </li>
                            <li className="mt-3 text-base leading-6">
                                Furthermore, at Edunique Transformation, I specialize as a front-end developer, 
                                leading the design and development of online learning platforms that aim to make 
                                a positive impact on students' success in STEM subjects.
                            </li>
                            <li className="mt-3 text-base leading-6">Contributing to open source projects with +50 other talented Software developers at <a href="https://github.com/congoclub" target="_blank" rel="noreferrer" className="text-blue-700 underline hover:text-blue-500">Congo Developers club</a></li>
                        </ul>

                    </section>

                    <section className='relative'>
                        {/* <!-- projects --> */}
                        <h2 className="text-xl mt-6 pb-1 border-b font-semibold">Technology Stack & Experiences</h2>
                        <ul className="list-disc text-base mt-4 pl-5">
                            <li> Javascript Technology - Fundamentals & Current Trends</li>
                            <li className='mt-2'> Mastering CSS & Frontend Architecture for web development</li>
                            <li className='mt-2'> Knowledge of CSS Preprocessors SCSS/SASS, PostCSS, Boostrap, Tailwind</li>
                            <li className='mt-2'> Knowledge of Cutting-edge Javascript Framework & Library such as: React and Nextjs</li>
                            <li className='mt-2'> Knowledge of Mongodb, Express js</li>
                            <li className='mt-2'> Knowledge of Module bundler such as Webpack and Parcel</li>
                            <li className='mt-2'> Knowledge of PHP Native & MVC Framework such as Ruby on rails and Laravel.</li>
                            <li className='mt-2'> currently developing Ruby on rails and Reactjs apps</li>
                            <li className='mt-2'> Focusing on clean code, conducting best practice as much as possible</li>
                        </ul>
                    </section>

                    <section className="overflow-hidden">
                        <h2 className="text-xl mt-6 pb-1 font-semibold">Github Calendar</h2>
                        <div className="mt-2 overflow-hidden">
                            <GitHubCalendar username="barakadanny" hideTotalCount hideColorLegend />
                        </div>
                    </section>
                </div>
            </main>
            <footer className="mt-6">
                <p className="bg-primaryGreen text-white text-center text-sm py-5">The best way to predict the future is to
                    create it. <small>- AbrahamLincoln</small>
                </p>
            </footer>
        </div>
      </div>
    </>
  )
}

export default About
